// extracted by mini-css-extract-plugin
export default {"container":"style_container__hnfPS","loadingWrapper":"style_loadingWrapper__s0qIM","navigatorWrapper":"style_navigatorWrapper__Glcbz","contentWrapper":"style_contentWrapper__5OOld"};